import { useDispatch, useSelector } from 'react-redux';
import { STATUSES } from 'legacy/appstore/constants';

import { mlsFetch } from 'actions/mls';
import { getMlsStatus, getMlsData } from 'selectors/mls';
import { useEffect } from 'react';

export const useMlsDisclaimer = (mlsId) => {
  const dispatch = useDispatch();
  const status = useSelector(getMlsStatus(mlsId));
  const data = useSelector(getMlsData(mlsId));
  useEffect(() => {
    if (!status || status === STATUSES.INIT) {
      dispatch(mlsFetch(mlsId));
    }
  }, [status, mlsId]);
  return data;
};
